import angular from 'angular';
import RtbPixelService from './service';

angular.module('generator.dsp.rtbPixel', [
  'ui.bootstrap',
  'generator.creativePreview'
]);

angular
  .module('generator.dsp.rtbPixel')
  .service('RtbPixelService', RtbPixelService);
